var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.137,
    height: 35.986,
    viewBox: "0 0 44.137 35.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project_1",
    "data-name": "Project 1",
    transform: "translate(-457.869 -532.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M480.109,567.212a1.869,1.869,0,0,1-.048-.384l.816-4.678a3.09,3.09,0,0,1,.648-1.391l.911-1.08,3-3.5,8.421-9.932v-6.358a7.2,7.2,0,0,0-7.2-7.2H465.067a7.188,7.188,0,0,0-7.2,7.2v21.591a7.188,7.188,0,0,0,7.2,7.2h16.841A1.806,1.806,0,0,1,480.109,567.212Zm-13.243-25.526h17.993a1.8,1.8,0,0,1,1.8,1.8,1.71,1.71,0,0,1-.384,1.1.825.825,0,0,1-.192.216,1.809,1.809,0,0,1-1.224.48H466.866a1.809,1.809,0,0,1-1.224-.48.823.823,0,0,1-.192-.216,1.71,1.71,0,0,1-.384-1.1A1.8,1.8,0,0,1,466.866,541.686Zm9,17.993h-9a1.782,1.782,0,0,1-1.8-1.8,1.255,1.255,0,0,1,.1-.5,1.675,1.675,0,0,1,1.128-1.2,1.615,1.615,0,0,1,.576-.1h9a1.8,1.8,0,0,1,0,3.6Zm-9-7.2a1.782,1.782,0,0,1-1.8-1.8,1.676,1.676,0,0,1,.432-1.151,1.781,1.781,0,0,1,1.368-.648h12.151a1.254,1.254,0,0,1,.5.1,1.76,1.76,0,0,1,1.271,1.391,1.365,1.365,0,0,1,.024.312,1.634,1.634,0,0,1-.432,1.151,1.707,1.707,0,0,1-1.367.648Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M472.688,551.573l-4.39,1.536a2.334,2.334,0,0,1-.408.024h4.75a7.188,7.188,0,0,0,7.2-7.2V543.8l-5.878,6.909A3.084,3.084,0,0,1,472.688,551.573Z",
    transform: "translate(14.019 15.543)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M488.108,540.5l-3.5-2.975a.733.733,0,0,0-.48-.168.756.756,0,0,0-.552.264l-3.359,3.958L468.8,555.017a1.635,1.635,0,0,0-.384.792l-.792,4.606a.626.626,0,0,0,.744.528l4.318-1.511a1.714,1.714,0,0,0,.744-.5l6.789-7.989,7.989-9.4A.75.75,0,0,0,488.108,540.5Z",
    transform: "translate(13.641 6.534)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/projectIcon.7f90c782986b4606ba57f5e60278b86b.svg";
export { ForwardRef as ReactComponent };